import { render } from "./ImmerseClubs.vue?vue&type=template&id=4c6cebcc&scoped=true"
import script from "./ImmerseClubs.vue?vue&type=script&lang=js"
export * from "./ImmerseClubs.vue?vue&type=script&lang=js"

import "./ImmerseClubs.vue?vue&type=style&index=0&id=4c6cebcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6cebcc"]])

export default __exports__